import axios from 'axios';
import useUserSession from '@/composables/useUserSession';

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL,
});

axiosInstance.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const { getAuthorizationHeader } = useUserSession();

export const useAxios = () => {
    const instance = axios.create({
        baseURL: import.meta.env.VITE_APP_API_URL,
        headers: getAuthorizationHeader(),
    });
    instance.interceptors.response.use(
        (response) => {
            // Pro arraybuffer potřebujeme celý response objekt (kvůli headers)
            if (response.config.responseType === 'arraybuffer') {
                return response;
            }
            return response.data;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    return instance;
};

export default axiosInstance;
